define('Components/AdvantageWidget/js/AdvantageWidget',['hooks','Components/AdvantageWidget/js/views/AdvantageWidgetInstanceView','Components/AdvantageWidget/js/models/AdvantageWidgetInstanceModel'],
    function(hooks, AdvantageWidgetInstanceView,AdvantageWidgetInstanceModel){

        return function(){
            hooks.registerWidgetInstance(
                'AdvantageWidget',
                AdvantageWidgetInstanceView,
                AdvantageWidgetInstanceModel
            );
        }

});
